
import { z } from 'zod';
import { QuestType } from '@/types/quests';

export const formSchema = z.object({
  name: z.string().min(3, { message: 'Quest name must be at least 3 characters' }),
  description: z.string().min(10, { message: 'Description must be at least 10 characters' }),
  points_awarded: z.coerce.number().min(1, { message: 'Points must be at least 1' }),
  type: z.enum(['daily', 'weekly', 'special_event', 'challenge']),
  badge_id: z.string().nullable().optional(),
  is_active: z.boolean().default(true),
  end_date: z.string().nullable().optional(),
});

export type FormValues = z.infer<typeof formSchema>;

export const getDefaultValues = () => ({
  name: '',
  description: '',
  points_awarded: 5,
  type: 'daily' as QuestType,
  badge_id: null,
  is_active: true,
  end_date: null,
});
